export default "__VITE_ASSET__DJUG4F20__"